import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button, IconButton, TextField, CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";

const NewTrnsRuSection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, trnsRu: !expanded.trnsRu });
    };

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.trnsRu} onChange={() => handleToggle("trnsRu")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.trns_ru?.length || 0}) יצירת תרגום לרוסית</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("trnsRu")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.trnsRu}
                    >
                        {loading.create.trnsRu ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Box>
                        {newInfo.trnsRu?.length > 0 ? (
                            newInfo.trnsRu.map((trns_ru, index) =>
                                <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", bgcolor: "#f0f0f0", p: 1, borderRadius: 2, mt: 0.5 }}>
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={trns_ru}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("trnsRu", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { trns_ru },
                                                    field: "trnsRu",
                                                    index
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.trnsRu?.[index]}
                                        >
                                            {trns_ru && (additionalInfo.loading.addExistsInfo.trnsRu?.[index] ? <CircularProgress size={24} /> : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("trnsRu", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    {/* שדה טקסט לעריכה */}
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={trns_ru}
                                        onChange={(e) => additionalInfo.editNewInfo("trnsRu", index, e.target.value)}
                                        sx={{ direction: /^[\u0590-\u05FF]/.test(trns_ru) ? "ltr" : "rtl" }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Typography variant="body2" color="textSecondary">לא נוצרו תרגומים לרוסית</Typography>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewTrnsRuSection;
